import type React from "react";
import { Clock } from "lucide-react";
import { Button } from "~/components/ui/button";
import { Tooltip } from "~/components/Tooltip";
import { cn } from "~/lib/utils";

// // // //

/** Shared sizing for the CTA row's buttons. */
export const ctaButtonClassName = cn(
    "h-9 min-h-9 w-full gap-1.5 px-3 py-0 text-sm font-medium leading-none shadow-xs",
    "[&_svg]:size-4",
);

/** Quiet white treatment for the secondary CTAs. */
export const secondaryCtaButtonClassName = cn(
    ctaButtonClassName,
    "bg-background text-secondary-foreground hover:bg-accent hover:text-foreground",
);

/** CTA button whose action is not yet wired up — disabled with a "Coming soon" tooltip. */
export function ComingSoonCtaButton(props: {
    icon: React.ReactNode;
    label: string;
}) {
    const { icon, label } = props;

    return (
        <Tooltip
            placement="top"
            tooltipContent={
                <div className="flex w-max items-center gap-1.5 px-2 py-1">
                    <Clock aria-hidden="true" className="size-3 opacity-70" />
                    <p className="whitespace-nowrap text-sm">Coming soon</p>
                </div>
            }
        >
            {({ setTriggerRef }) => (
                <span ref={setTriggerRef} tabIndex={0} className="min-w-0">
                    <Button
                        type="button"
                        variant="outline"
                        size="sm"
                        className={secondaryCtaButtonClassName}
                        disabled
                        aria-label={`${label} (coming soon)`}
                    >
                        {icon}
                        {label}
                    </Button>
                </span>
            )}
        </Tooltip>
    );
}
